import { useState } from "react";
import { useProfileImageModalStore } from "../../../js/stores/profile-image-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { ProfileImageModal } from "./profile-image-modal";

/** Mirrors avatar.UmbracoImage?.GetCropUrl(100, 100) in Views/MyProfile.cshtml. */
const AVATAR_CROP = "?rmode=crop&width=100&height=100";

export const ProfileImageWidget = ({
  avatarUrl,
  externalAvatarUrl,
  avatarInitials,
  maxFileSizeBytes,
}) => {
  const isModalOpen = useProfileImageModalStore((state) => state.isModalOpen);
  const openModal = useProfileImageModalStore((state) => state.openModal);
  const closeModal = useProfileImageModalStore((state) => state.closeModal);
  const updateIsModalOpen = useProfileImageModalStore(
    (state) => state.updateIsModalOpen
  );

  const [avatar, setAvatar] = useState(avatarUrl);
  const [previewAngle, setPreviewAngle] = useState(0);

  // Rotation only applies to an image the member uploaded. An Auth0 avatar or the initials
  // fallback is not ours to rewrite, so the controls do not appear for those.
  const hasUploadedImage = !!avatar;

  return (
    <div className="profile-image__wrapper">
      <div
        className="profile-image__avatar"
        data-testid="profile-avatar"
        style={{backgroundImage: `url(${avatar || externalAvatarUrl})`}}
      >
        {avatarInitials}
      </div>

      <button className="profile-image__popup-button" onClick={openModal}>Upload image</button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => updateIsModalOpen(false)}
          onOpenChange={updateIsModalOpen}
        >
          <DialogContent>
            <ProfileImageModal
              closeModal={closeModal}
              maxFileSizeBytes={maxFileSizeBytes}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  )
}
